import Axios from 'axios'

const axios = (isWebcrawler = false) => {
  // axios instance for making requests
  
  let  axiosInstance = Axios.create({
    baseURL: isWebcrawler ? process.env.VUE_APP_WEBCRAWLER_URL + '/api' : process.env.VUE_APP_SERVER_URL + '/api',
    // timeout: 30 * 1000
  });

  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.authorization = token;
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  return axiosInstance;
};


export default axios;